import { Loading } from '@acin/ui-core';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ControlMappingsRoutes } from './ControlMappingsRoutes';
import { HomepageRoutes } from './HomepageRoutes';
import { RegulationRoutes } from './RegulationRoutes';
import ScrollToTop from './ScrollToTop';
import { ROUTES } from './routes';

const RouteNotFound = () => (
  <Route path="*">
    <div>Error 404! Page not found</div>
  </Route>
);

export const PrivateLayout = () => {
  return (
    <React.Suspense fallback={<Loading position="absolute" withOverlay />}>
      <ScrollToTop />
      <Switch>
        <Route exact path={ROUTES.HOMEPAGE.path}>
          <HomepageRoutes />
        </Route>

        <Route path={ROUTES.REGULATIONS_OVERVIEW.path}>
          <RegulationRoutes />
        </Route>

        <Route path={ROUTES.CONTROL_MAPPINGS.path}>
          <ControlMappingsRoutes />
        </Route>

        <RouteNotFound />
      </Switch>
    </React.Suspense>
  );
};
